import { lazy, Suspense, useEffect,useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';
import { setIsAuthenticated } from 'state/slices/authSlice';
import { setUserData } from 'state/slices/userSlice';
import { RootState } from 'state/store';

import { BaseLayout } from 'components/layout/BaseLayout';
import Loader from 'components/Loader';
import PageNotFound from 'components/PageNotFound';

import Login from './auth/Login';

const WaitlistDashboard = lazy(() => import('views/waitlist/WaitlistDashboard'));

function App() {
  const [useMockLogin] = useState<boolean>(true); // Enable mock login for development
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [authVerificationCompleted, setAuthVerificationCompleted] = useState(false);
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);





  useEffect(() => {
    async function doSignIn() {
      if (useMockLogin || process.env.NODE_ENV === 'development') {
        // Mock authentication for development
        dispatch(setIsAuthenticated(true));
        dispatch(setUserData({
          id: 'mock-user-1',
          email: 'admin@waitlist.com',
          name: 'Admin User',
          role: 'admin'
        }));
        setAuthVerificationCompleted(true);
        setIsLoading(false);
        return;
      }

      setAuthVerificationCompleted(true);
      setIsLoading(false);
    }
    
    doSignIn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!authVerificationCompleted || isLoading) return <Loader />;

  if (isAuthenticated && !useMockLogin && process.env.NODE_ENV === 'development') {
    window.history.replaceState(null, '', '/');
  }

  if (isAuthenticated) {
    return (
      <Suspense fallback={<Loader />}>
        <RouterProvider 
          router={createBrowserRouter(
            createRoutesFromElements(
              <>
                <Route path="/" element={<BaseLayout><WaitlistDashboard /></BaseLayout>} />
                <Route path="*" element={<BaseLayout><PageNotFound /></BaseLayout>} />
              </>,
            ),
          )}
        />
      </Suspense>
    );
  }

  return (
    <Suspense fallback={<Loader />}>
      <RouterProvider 
        router={createBrowserRouter(
          createRoutesFromElements(
            <Route path="*" element={<Login setIsLoading={setIsLoading} />} />
          ),
        )}
      />
    </Suspense>
  );
}

export default App; 